<!-- 企业介绍 -->
<template>
    <div class='companyProfile'>
        <div class="banner">
            <img src="../../assets/aboutUs/companyProfile/企业介绍banner.jpg" alt="">
        </div>
        <div class="main">
            <div class="qyjs">
                <div class="title">企业介绍</div>
                <P>探见集团是一家以”绿色建筑内外装饰全场景探索者“为核心发展理念，融设计院系统、绿色低碳建筑材料系统、智慧落地系统为一体的专业化建筑科技集团。</P>
                <P> 探见集团作为绿色建筑的国家高新技术企业及专精特新企业，拥有100+以上的研发技术服务团队，拥有国家建筑幕墙工程专业承包一级、设计专项甲级资质，装修装饰工程专业承包一级资质等。集团公司还拥有多项发明与实用新型，获中国门窗、幕墙、精装修类十强荣誉，获评5A供应商，3A信用企业。
                </P>
                <P> 时至今日，我们在政府公建、商业空间、工矿企业、地产等领域拥有众多合作伙伴，业务范围辐射全国，并积极开拓海外市场，与国内知名央国企、地方性投资公司、医疗康养、星级酒店以及地产等达成了长期战略合作伙伴关系。
                </P>
            </div>
            <div class="ryzz">
                <div class="title">荣誉资质</div>
                <div class="list">
                    <div class="list-warp">
                        <div class="item">
                            <img style="width: 160px;" src="../../assets/aboutUs/companyProfile/专精特新.jpg" alt="">
                            <div class="text">专精特新中小企业证书</div>
                        </div>
                        <div class="item">
                            <img style="width: 300px;" src="../../assets/aboutUs/companyProfile/高新技术企业.jpg" alt="">
                            <div class="text">国家高新技术企业证书</div>
                        </div>
                        <div class="item">
                            <img style="width:148px;" src="../../assets/aboutUs/companyProfile/3A信用.png" alt="">
                            <div class="text">AAA信用等级</div>
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img style="width:148px;" src="../../assets/aboutUs/companyProfile/建筑幕墙工程专业承包一级.png" alt="">
                            <div class="text">建筑幕墙工程专业承包一级</div>
                        </div>
                        <div class="item">
                            <img style="width:148px;" src="../../assets/aboutUs/companyProfile/建筑幕墙工程设计专项甲级.png" alt="">
                            <div class="text">建筑幕墙工程设计专项甲级</div>
                        </div>
                        <div class="item">
                            <img style="width:148px;" src="../../assets/aboutUs/companyProfile/建筑装修装饰工程专业承包一级.jpg" alt="">
                            <div class="text">建筑装修装饰工程专业承包一级</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dxal">
                <div class="title">典型案例</div>
                <!-- <div class="list">
                    <div class="list-warp">
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                        <div class="item">
                            <img src="" alt="">
                            <div class="text">案例1</div>
                        </div>
                    </div>
                </div> -->
                <div class="swiper">
                    <el-carousel :interval="5000" type="always" height="675px">
                        <el-carousel-item>
                            <img src="../../assets/aboutUs/companyProfile/1-G60.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/aboutUs/companyProfile/2-MAX.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/aboutUs/companyProfile/3-精装修.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/aboutUs/companyProfile/4-门窗.jpg" alt="">
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../../assets/aboutUs/companyProfile/5-中铁建幕墙.jpg" alt="">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <!-- <div class="qywh">
                <div class="title">企业文化</div>
                <img src="" alt="">
            </div> -->
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.companyProfile {
    width: 100%;

    .banner {
        width: 100%;
        height: calc(100vh - 48px);
        background-color: #999;
        margin-bottom: 20px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .main {
        width: 1200px;
        margin: 0 auto;

        .qyjs {
            .title {
                width: 100%;
                text-align: center;
                margin: 30px auto;
                font-weight: bolder;
                font-size: 28px;
                color: #000;
            }

            p {
                font-size: 14px;
                margin-bottom: 20px;
            }
        }

        .ryzz {
            margin-top: 20px;

            .title {
                width: 100%;
                text-align: center;
                margin: 30px auto;
                font-weight: bolder;
                font-size: 28px;
                color: #000;
            }

            .list {
                padding: 20px 120px;
                background-color: rgb(244, 244, 244);

                .list-warp {
                    display: flex;
                    justify-content: space-between;

                    .item {
                        width: 30%;

                        img {
                            display: block;
                            margin: 20px auto;
                            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
                            // width: 100px;
                            // height: 100px;
                        }

                        .text {
                            width: 100%;
                            margin: 0 auto;
                            text-align: center;
                            font-size: 12px;
                            color: rgb(172, 172, 172);
                        }
                    }
                }
            }
        }

        .dxal {
            margin-bottom: 100px;

            .title {
                width: 100%;
                text-align: center;
                margin: 30px auto;
                font-weight: bolder;
                font-size: 28px;
                color: #000;
            }

            .list {

                .list-warp {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .item {
                        display: flex;
                        flex-direction: column;
                        width: 30%;

                        img {
                            display: block;
                            margin: 20px auto;
                            width: 100%;
                            height: 200px;
                            background-color: #999;
                        }

                        .text {
                            width: 100%;
                            margin: 0 auto;
                            text-align: center;
                            font-size: 12px;
                            color: rgb(172, 172, 172);
                        }
                    }
                }
            }

            .swiper {
                img {
                    width: 100%;
                }
            }
        }

        .qywh {
            .title {
                width: 100%;
                text-align: center;
                margin: 30px auto;
                font-weight: bolder;
                font-size: 28px;
                color: #000;
            }

            img {
                width: 100%;
                height: 449px;
                background-color: #999;
            }
        }
    }


}
</style>